function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  y: 96,
  width: 96,
  height: 78,
  rx: 4,
  transform: "rotate(-90 0 96)",
  fill: "#1C1C1C"
});
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 21,
  y: 41,
  width: 102,
  height: 65,
  rx: 3,
  fill: "#29353F",
  stroke: "#fff",
  strokeWidth: 2
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M102 24.454L109.778 31 116 23",
  stroke: "#F8DC00",
  strokeWidth: 2,
  strokeLinecap: "round"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M109 30a1 1 0 002 0h-2zm-.599-8.036l-.923.382.923-.382zm-4.552-6.813l.707-.707-.707.707zm-6.813-4.553l-.382.924.382-.924zM89 8a1 1 0 100 2V8zm22 22c0-2.89-.569-5.75-1.675-8.419l-1.847.765A20.002 20.002 0 01109 30h2zm-1.675-8.419a21.987 21.987 0 00-4.769-7.137l-1.414 1.414a20.018 20.018 0 014.336 6.488l1.847-.765zm-4.769-7.137a22.002 22.002 0 00-7.137-4.77l-.765 1.848a19.997 19.997 0 016.488 4.336l1.414-1.414zm-7.137-4.77A22 22 0 0089 8v2a20 20 0 017.654 1.522l.765-1.847z",
  fill: "#F8DC00"
});
function SvgRotateScreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 107,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4);
}
export default SvgRotateScreen;